import {
  ActionIcon,
  Alert,
  Box,
  Button,
  Center,
  FileInput,
  Group,
  Image,
  Modal,
  NumberInput,
  Text,
  TextInput,
  Title,
} from "@mantine/core";

import { useDisclosure } from "@mantine/hooks";
import {
  IconAlertCircle,
  IconCheck,
  IconCircleCheck,
  IconPlus,
  IconQrcode,
  IconTrash,
} from "@tabler/icons-react";
import React, { useReducer, useState } from "react";
import logo from "../../assets/logo.png";

import { notifications } from "@mantine/notifications";
import { url } from "../settings/linkUrl";

interface dataremove {
  nameBtn?: string;
  onLoadPage: () => any;
}

export default function AppModelConfrimSave({
  onLoadPage,
  nameBtn,
}: dataremove) {
  const [opened, { open, close }] = useDisclosure(false);

  const funcApprove = () => {
    close();
    onLoadPage();
  };

  return (
    <>
      <Modal
        opened={opened}
        onClose={close}
        size="sm"
        centered
        title="การลงทะเบียน"
        transitionProps={{
          transition: "fade",
          duration: 300,
          timingFunction: "linear",
        }}
      >
        <Text fz="sm">
          {`ท่านต้องการ${nameBtn}ซ้อมรับพระราชทานปริญญาบัตรหรือไม่ ?`}
        </Text>

        <Group justify="flex-end" mt="md">
          <Button onClick={funcApprove}>ยืนยัน</Button>
          <Button color="red" onClick={close}>
            ยกเลิก
          </Button>
        </Group>
      </Modal>
      <Button
        leftSection={<IconCheck />}
        variant="gradient"
        gradient={{ from: "indigo", to: "cyan" }}
        onClick={open}
      >
        {nameBtn}
      </Button>
    </>
  );
}
